import { Skeleton } from '../ui/skeleton/skeleton';

interface SkeletonCardProps {
  className?: string;
}

export function SkeletonCard({ className }: SkeletonCardProps) {
  return <Skeleton className={`w-full h-full bg-skeleton rounded-[8px] ${className} `} />;
}
